import React from 'react';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import baseService from '../../../lib/service/ServiceBase';
import './Home.less';

import Layout from '../components/Layout/LayoutIndex';
import { getHtmlTDK, getVal, locationTo, getJumpLink } from '../../../lib/utils/UtilsCommon';

import BottomFloat from '../components/bottom-float/BottomFloat';
import ReactSwiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import Picture from '../../../components/picture/Picture';
import CourseItem from '../components/course-item/CourseItem';
import { MediaPlayerCover } from '../../../components/audio/AudioPlayerCover';

/**
 * state
 */
interface IState {
	htmlTDK: {
		title: string;
	};
}

/**
 * HomeIndex page
 *
 * @class HomeIndex
 * @extends {React.Component<any>}
 */
@autobind
class HomeIndex extends React.Component<any, any> {
	private mediaPlayer: any = null;

	constructor(props: any, context?: any) {
		super(props, context);

		/**
		 * 静态化渲染数据放这里处理
		 */

		let { initData } = props;
		console.log(initData);

		const state: any = {
			htmlTDK: {
				title: '千聊_专注实用知识的内容平台_与知识做朋友',
				pageDescription: '千聊是一个专注于知识分享的平台，让您直接找到各个领域的专家、老师、达人等知识从业者的精品课程。现场在线，实时互动，可听课、可购买干货内容，可和学友讨论、可和讲师问答，是一个你私人所属的24小时在线的知识智囊团。',
				pageKeyword: '千聊,微课,群直播,知识付费,内容付费,知识服务,开课,知识从业者,女性内容',
			},
			indexData: getVal(initData, 'indexData.data.regions', []),
			newTopics: getVal(initData, 'newTopics.data.dataList', []),
			banners: [
				{
					backgroundUrl: 'https://img.qlchat.com/qlLive/activity/image/41UBVJGP-8W8L-7ONU-1604974884715-88YVWQVS61GB.jpg',
					type: 'channel',
					id: '2000011287275626',
				},
				{
					backgroundUrl: 'https://img.qlchat.com/qlLive/activity/image/PF7PGZJT-6TC5-QE6X-1604974889375-BAZ7OHGXLVWB.jpg',
					type: 'channel',
					id: '2000010665334420',
				},
				{
					backgroundUrl: 'https://img.qlchat.com/qlLive/activity/image/LCC7GTZE-V9CA-PPV3-1604974892793-3DEXQ2IO5OU6.jpg',
					type: 'channel',
					id: '2000011674535043',
				},
				{
					backgroundUrl: 'https://img.qlchat.com/qlLive/activity/image/UASTFEHZ-X32J-3JWB-1604974897970-U5KDJ9LOQGXR.jpg',
					type: 'channel',
					id: '2000011360889700',
				},
				{
					backgroundUrl: 'https://img.qlchat.com/qlLive/activity/image/BZ2W3IYY-ES94-7LZS-1604974902874-LSRNSOUE3EI2.jpg',
					type: 'channel',
					id: '2000009863461052',
				},
			],
			bsId: '',
		};

		this.state = state;
	}

	/**
	 * 动态渲染数据放这里处理
	 *
	 * @static
	 * @param {*} { req }
	 * @returns {Promise<any>}
	 * @memberof HomeIndex
	 */
	public static async getInitialProps(context: any): Promise<any> {
		const { query, params } = context.req;
		// 注册接口
		baseService.register(context);

		let initData: any = {
			...params,
		};

		// 首屏数据
		await Promise.all([
			baseService.getHomeTags(),
			baseService.getHomeIndex(),
			baseService.commonApi({
				url: '/h5/topic/getNewestTopicList',
			}),
		]).then((res: any[]): void => {
			initData.tags = res[0];
			initData.indexData = res[1];
			initData.newTopics = res[2];
		});

		return {
			query,
			initData,
			sysTime: Date.now(),
		};
	}

	/**
	 * 客户端调用获取数据
	 *
	 * @memberof HomeIndex
	 */
	public async componentDidMount(): Promise<any> {
		// 注册接口
		baseService.register(this.props);

		this.initMediaPlayer();

		return {};
	}
	/**
	 * 回到顶部
	 */
	public toTopFunc(): any {
		console.log('home to top');
		let warpEl: any = document.getElementsByClassName('home-parent-box')[0];
		warpEl.scrollTop = 0;
	}

	/**
	 * 展示二维码
	 */
	public async showQr(): Promise<any> {
		let qrUrl: any = this.state.qrUrl;

		if (!qrUrl) {
			qrUrl = await baseService
				.commonApi({
					url: '/h5/qr/getQr',
					body: {
						appId: 'wx9a7beaf7d8e10f96',
						channel: 'webhomepage',
					},
				})
				.then((res: any): void => getVal(res, 'data.qrInfo.url', null));
			this.setState({ qrUrl });
		}

		window.showQr({
			qrDesc: '扫描二维码，发现更多精彩课程内容',
		});
	}

	/**
	 * 初始化隐藏播放器（用于试听）
	 */
	public initMediaPlayer(): void {
		let updateStatus: any = (status: any): void => {
			this.setState({
				playStatus: status,
			});
		};
		const ended: any = (): void => {
			this.showQr();
		};
		this.mediaPlayer = new MediaPlayerCover({ updateStatus, ended });
	}

	/**
	 * 试听播放
	 */
	public async auditionPlaying(type: string, id: string): Promise<any> {
		if (this.state.bsId === id) {
			this.mediaPlayer.resume();
		} else {
			this.mediaPlayer.pause();
			this.setState({
				bsId: id,
			});
			try {
				const res: any = await baseService.getCourseAuditionList({
					businessId: id,
					businessType: type.toUpperCase(),
				});
				let list: any[] = getVal(res, 'data.result.contentList', []);
				if (list.length) {
					let totalSeconds: number = getVal(res, 'data.result.totalSeconds', 0);
					this.mediaPlayer.mediaPlayerUpdate(list, totalSeconds, type === 'topic', type === 'topic' ? 300 : null);
					this.mediaPlayer.play();
				} else {
					window.toast('暂未开课，先试听其他课吧~');
					this.setState({
						bsId: '',
						playStatus: 'stop',
					});
				}
			} catch (error) {
				window.toast('网络请求超时~');
				this.setState({
					bsId: '',
					playStatus: 'stop',
				});
			}
		}
	}

	/**
	 * 试听暂停
	 */
	public auditionPause(): void {
		this.mediaPlayer.pause();
	}

	/**
	 * 渲染页面
	 *
	 * @returns {*}
	 * @memberof HomeIndex
	 */
	public render(): any {
		const { banners, htmlTDK, newTopics } = this.state;
		const opts: any = {
			autoplay: {
				delay: 3000,
			},
		};
		const opts2: any = {
			className: 'topic-list-holder',
			autoplay: {
				delay: 3000,
			},
			direction: 'vertical',
			loop: true,
		};

		return (
			<Layout
				{...getHtmlTDK(htmlTDK)}
				bodyClass="home-page"
				resetClass="home-parent-box"
				region="create-live_pc_homepage_top_tab"
				topicListEl={
					newTopics && newTopics.length > 0 ? (
						<div className="topic-list-holder">
							<ReactSwiper {...opts2}>
								{newTopics.map((item: any, index: number): any => (
									<li key={`topic-list-holder-${index}`} className="topic-list-holder-item">
										<a href={getJumpLink(item.businessType, item.id)}>{item.name}</a>
									</li>
								))}
							</ReactSwiper>
						</div>
					) : null
				}>
				<div className="main-container">
					<div className="type-box">
						<div className="type act">
							<div className="name elli">推荐</div>
						</div>
						{this.props.categoryList.first.slice(0, 9).map((item: any, idx: number): any => (
							<div className="type" key={idx}>
								<a className="name elli" href={`/frontend/tags/${item.id}/0/p1/`}>
									{item.name}
								</a>
							</div>
						))}
					</div>
					<div className="top-banner">
						<ReactSwiper {...opts}>
							{banners.map((item: any, index: number): any => (
								<a key={`recommend-swiper-item${index}`} data-url={`${item.url}`} href={getJumpLink(item.type, item.id)} className="recommend-swiper-item on-log on-visible-banner" data-log-region="banner" data-log-pos={index} data-log-business_id={item.mainId} data-log-name={item.topic} data-log-business_type={item.type}>
									<Picture src={item.backgroundUrl} placeholder />
								</a>
							))}
						</ReactSwiper>
						<div className="right-qr">
							<img src="https://img.qlchat.com/qlLive/activity/image/C1W3V3GI-TVLB-JOET-1604901796523-4ARIZLEG7K4W.png" alt="" />
							<div className="text1">扫描二维码下载</div>
							<div className="text2">免费领取1000+精品课程</div>
							<div className="text2">和知识做朋友</div>
						</div>
					</div>
					<div className="part-box">
						<div className="part free" onClick={this.showQr}>
							免费必听
						</div>
						<div className="part master" onClick={this.showQr}>
							大师课
						</div>
						<div className="part members" onClick={this.showQr}>
							超值会员
						</div>
						<div className="part coupon" onClick={this.showQr}>
							领券中心
						</div>
						<div className="part rang" onClick={this.showQr}>
							排行榜
						</div>
					</div>

					{this.state.indexData.map((block: any, idx: number): any => {
						switch (block.type) {
							case 'news':
								return block.newsCourseList && block.newsCourseList.length ? (
									<div className="teacher-box" key={idx}>
										<div className="title">{block.name}</div>
										<div className="teacher-list">
											{block.newsCourseList.map((item: any, subIdx: number): any => (
												<div className="teach" key={subIdx} onClick={this.showQr}>
													<div className="top elli-text">{item.topicName}</div>
													<div className="bottom">
														<img src={item.teacherImage} alt="" />
														<span>
															{item.teacherName}·{item.teacherIntro}
														</span>
													</div>
												</div>
											))}
										</div>
									</div>
								) : null;
							case 'boutique':
							case 'nightchat':
							case 'master':
							case 'rank':
							case 'interest':
							case 'favorite':
							case 'classify':
							case 'child':
							case 'exclusive':
								return block.courses && block.courses.length ? (
									<div className="section-box" key={idx}>
										<div className="section-title">{block.name}</div>
										{/* <div className="btn-more">更多</div> */}
										<div className="course-list">
											{block.courses.map((item: any, subIdx: number): any => (
												<CourseItem key={subIdx} businessId={item.businessId} poster={`${item.logo}?x-oss-process=image/resize,m_fill,limit_0,w_288,h_180`} title={item.businessName} businessType={item.businessType} topicNum={item.planCount || item.topicNum} learningNum={item.learningNum} playing={this.auditionPlaying} selctId={this.state.bsId} auditionPause={this.auditionPause} playStatus={this.state.playStatus} />
											))}
										</div>
									</div>
								) : null;
							case 'camp': // 训练营
							case 'hotBuy': // 限时秒杀
							case 'qlTweet': // 千聊推文
							case 'univ_community': // 女子大学
							case 'qlVip': // 千聊会员
							case 'recommend': //  广告位
							case 'campAds': //  广告位
							case 'freePublic': // 公开课
							case 'book': // 听书
							default:
								return null;
						}
					})}
				</div>

				<BottomFloat />
			</Layout>
		);
	}
}

/**
 * mapStateToProps
 */
function mapStateToProps(state: any): any {
	return {
		categoryList: state.common.categoryList,
	};
}

const mapActionToProps: any = {};

export default connect(mapStateToProps, mapActionToProps)(HomeIndex);
